import { CreateUserForm } from '../../features/CreateUserForm';

const CreateUserPage = () => {
  return <CreateUserForm />;
};

export default CreateUserPage;
